<template>
  <!--
      作者：luoyiming
      时间：2020-06-01
      描述：插件中心-文章-添加
    -->
  <div class="product-add pb50">
   <!--添加文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加</div>
      <el-form-item label="标题" prop="chapter_name"><el-input v-model="form.chapter_name" placeholder="请输入标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="描述" prop="chapter_content"><el-input v-model="form.chapter_content" placeholder="请输入文章描述" type="textarea" class="max-w460"></el-input></el-form-item>
      <el-form-item label="缩略图">
        <div>

          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img :src="path" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
          <el-input v-model="form.image_id" type="hidden"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="视频类型">
        <el-radio-group v-model="form.video_type">
          <el-radio :label="10">本地上传</el-radio>
          <el-radio :label="20">外部链接</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="视频：" prop="video_path" v-if="form.video_type ==10">
        <el-input type="text" v-model="form.video_path" placeholder="请选择视频" class="max-w460">
          <template slot="append">
            <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="外部视频链接" prop="video_path" v-if="form.video_type ==20">
        <el-input v-model="form.video_path" placeholder="请输入外部视频链接地址" class="max-w460"></el-input>
        <div class="tips">
          <p>输入完整的视频链接地址。例如：http://www.xxx.com</p>
         
        </div>
      </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传视频组件-->
    <Video v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频
    </Video>
  </div>
</template>

<script>
import CourseApi from '@/api/course.js';
import Video from '@/components/file/Video';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*视频上传*/
    Video: Video,
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      isVideoUpload:false,
      path: '',
      /*form表单数据*/
      form: {
        chapter_name: '',
        image_id: '',
        chapter_content: '',
        video_path:'',
        video_type:20,
      },

      loading: false,
      /*验证规则*/
      rules: {
        chapter_name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        chapter_content: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        video_path: [{ required: true, message: '请选择视频', trigger: 'blur' }]
      }
    };
  },
  created() {

  },
  methods: {
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /* 打开视频 */
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      if (e != null && e.length > 0) {
        this.form.video_path = e[0].file_path;
      }
      this.isVideoUpload = false;
    },
    /*添加章节*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CourseApi.chapterAdd(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              localStorage.setItem('activeName','first')
              self.$router.push('/plus/course/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回文章列表*/
    cancelFunc() {
      localStorage.setItem('activeName','first')
      this.$router.push({
        path: '/plus/course/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/course/chapter/add.vue